import React from "react";
import InquiryTable from "components/Cards/InquiryTable";


export default function Contact() {
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <InquiryTable />
        </div>
      </div>
    </>
  );
}
